import { cn } from "@/lib/utils";

function ErrorMessage({
  className,
  children,
  ...otherProps
}: React.ComponentProps<"span">) {
  if (!children) return null;
  return (
    <span
      className={cn("text-sm text-red-400 mt-2.5 pl-1.5 block", className)}
      {...otherProps}
    >
      {children}
    </span>
  );
}

export default ErrorMessage;
